import { render } from "./AddAndUpdateInclusionModal.vue?vue&type=template&id=745a4e66&scoped=true&ts=true&lang=pug"
import script from "./AddAndUpdateInclusionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddAndUpdateInclusionModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddAndUpdateInclusionModal.vue?vue&type=style&index=0&id=745a4e66&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745a4e66"]])

export default __exports__